// Live-preview editor flag (Walter 2026-07-12).
//
// Device-local, opt-in switch that swaps the note <textarea> for the
// CodeMirror-6 MarkdownEditor (Obsidian-style live preview). Stored in
// localStorage — NOT in Firestore userPrefs — because it's an experimental,
// per-device preference that shouldn't sync across a user's devices while it's
// still rough. Toggled from Settings → experimental; a page reload is required
// for the swap to take effect (the editor is chosen at render time).

export const LIVE_PREVIEW_EDITOR_KEY = 'listicity:livePreviewEditor';

export function isLivePreviewEditorEnabled() {
  try {
    return localStorage.getItem(LIVE_PREVIEW_EDITOR_KEY) === '1';
  } catch {
    return false;
  }
}

// Walter 2026-07-17: the ≥768px desktop-only gate is GONE. It existed because
// of a "CM6 collapses on narrow viewports" observation (#126/#137) that turned
// out to be an automation-environment artifact — a stalled sidebar width
// TRANSITION squeezed the tile to 0px in the throttled preview pane, and it
// squeezed the textarea exactly the same. On a real narrow viewport CM6 lays
// out fine (verified at 393×800: full-width lines, wrapping, no horizontal
// overflow, typing works). The flag itself is still dev-gated + per-device
// opt-in, so mobile exposure remains contained to Walter's own testing.
export function isLivePreviewEditorActive() {
  return isLivePreviewEditorEnabled();
}

export function setLivePreviewEditorEnabled(on) {
  try {
    if (on) localStorage.setItem(LIVE_PREVIEW_EDITOR_KEY, '1');
    else localStorage.removeItem(LIVE_PREVIEW_EDITOR_KEY);
  } catch {
    /* private-mode / storage-disabled — flag simply won't persist */
  }
}
